import { UserCircle } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const governanceSubNav: RouteListItem[] = [
  {
    path: '/governance/$id',
    icon: UserCircle,
    name: 'Governance',
  },
];
